module.exports = __webpack_public_path__ + "static/media/yt.ffac0264.jpg";